function apiUrlBuilder(subdomain = '') {
  const { API_PROTOCOL, API_HOST } = process.env
  const url = `${API_PROTOCOL}://`
  if (subdomain.length) return `${url}${subdomain}.${API_HOST}`
  return `${url}${API_HOST}`
}

export default apiUrlBuilder
